import { Component } from '@angular/core';

@Component({
  selector: 'mtm-red-circle-icon',
  templateUrl: './red-circle-icon.component.html',
  styleUrls: [],
  standalone: false,
})
export class RedCircleIconComponent {}
